import Vue from 'vue';
import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default Vue.component('dynamic-input-social', {
  template: require('./template.html'),
  name: 'dynamic-input-social',
  mixins: [guid],
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
  ],
  data() {
    return {
      strictId: null,
    };
  },
  created() {
    this.strictId = this.guid();
  },
  methods: {
    toggleIcon(icon) {
      this.$store.dispatch('setDropletVal', {
        drp: icon,
        key: 'active',
        val: !icon.active,
      });
    },
    updateLink(e, icon) {
      this._debounce(() => {
        this.$store.dispatch('setDropletVal', {
          drp: icon,
          key: 'link',
          val: this._getInputVal(e.target.value),
        });
      }, 250);
    },
    startCase(text) {
      return _.startCase(text);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/social-media/index.js